import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { Observable } from 'rxjs';
import { selectContract, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { DealerBasicData } from '../../constants/dealer-basic-data';
import { Contract } from '../../models/contract.model';
import { MatSelectModule } from '@angular/material/select';


@Component({
    selector: 'app-contract-dialog',
    templateUrl: './contract-dialog.component.html',
    styleUrls: ['./contract-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, AsyncPipe, MatSelectModule]
})
export class ContractDialogComponent implements OnInit{

  disabled = false;

  contractTypes = DealerBasicData.contractTypes;

  isNew: boolean = false; 

  contract$ : Observable<Contract | undefined>;
  contract: Contract = new Contract();

  currentUserId$ : Observable<string>;
  currentUserId: string = "";
  
  constructor(
    public dialogRef: MatDialogRef<ContractDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectData,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

      this.currentUserId$ = store.select(selectLoggedInUserDataId);
      this.contract$ = store.select(selectContract( data.objectSource, data.offerId, data.objectId, data.transactionRole )); 

    }

    ngOnInit(): void {
      this.isNew = (this.data.objectId === 0);
    
      this.currentUserId$.subscribe(
          (id: string) => this.currentUserId = id
      );

      this.contract$.subscribe(
        (conv: Contract | undefined) => {
          this.contract = conv == undefined ? new Contract() : JSON.parse(JSON.stringify(conv))
        }
      );
  
    } 

    submitContract(){
      
      if(this.contract.contractId === ""){
        this.store.dispatch(DealerActions.contractNewSubmit ( { contract: this.contract, objectSource: this.data.objectSource }));
      }
      else{
        this.store.dispatch(DealerActions.contractUpdateSubmit ( { contract: this.contract, objectSource: this.data.objectSource })); 
      }
      this.dialogRef.close();
    }
}
